import { useContext } from 'react';
import { FeatureFlagsContext, type FeatureFlagsContextValue } from './featureFlagsContext';

/**
 * The signed-in user's feature flags: `isEnabled(key)` and `refresh()`.
 *
 * The list is loaded once per session by `FeatureFlagsProvider` (mounted in `App`), so calling this
 * from many components costs no extra requests. It never throws: a failed or missing endpoint
 * reads as every flag off.
 */
export const useFeatureFlags = (): FeatureFlagsContextValue => useContext(FeatureFlagsContext);
